// 动态路由

export default (name) => () =>
import(`@/view/${name}`)



// WEBPACK FOOTER //
// ./src/utils/lazyLoading.js